export default __webpack_public_path__ + "static/media/DR.JC-black.4bd07ddb.svg";